import { useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import useCmsQuery from './useCmsQuery.tsx';
import { getCountries, TCountry } from '../../cms';
import { buildAppError } from '../../flow/errors/errorBuilder.ts';
import { FE_ERROR_CODES } from '../../flow/errors/errorCodes.ts';

export type { TCountry };

const useCountriesData = (): {
  countries: TCountry[]; isLoading: boolean; error: unknown;
} => {
  const { showBoundary } = useErrorBoundary();
  const { data, loading, error } = useCmsQuery(() => getCountries(), []);

  useEffect(() => {
    if (error) showBoundary(buildAppError(FE_ERROR_CODES.unknown_error, { originalError: error }));
  }, [error, showBoundary]);

  return { countries: data ?? [], isLoading: loading, error };
};

export default useCountriesData;
